<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <!--ver para que el lazy validation xD -->
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs12 md12>
          <v-card max-width="100%" height="130">
            <v-card-text>Nivel: {{ idNivel }}</v-card-text>
            <v-card-text>Tipo De Prueba: {{ tipoPrueba }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Código curso"
            single-line
            hide-details
            v-on:keydown.enter.prevent="loadData()"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md1></v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            item-text="nombre"
            item-value="code"
            :items="regionesSelect"
            label="Región"
          ></v-select>
        </v-flex>
        <v-flex xs12 md1></v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            item-text="nombre"
            item-value="code"
            :items="comunasSelect"
            label="Comuna"
          ></v-select>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex md12>
          <v-layout>
            <v-flex lg12>
              <div v-if="loading">
                <loading></loading>
              </div>
              <div v-if="alerta">
                <alert-empty></alert-empty>
              </div>
              <v-spacer></v-spacer>
              <template>
                <v-data-table
                  :headers="headers"
                  :items="itemsDestruccion"
                  :search="search"
                  :rows-per-page-items="rowsPerPageItems"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                    <td class="text-xs-left">{{ props.item.idNivel }}</td>
                    <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                    <td class="text-xs-left">{{ props.item.cantLC }}</td>
                    <td class="text-xs-left">{{ props.item.cantFa }}</td>
                    <td class="text-xs-left">{{ props.item.cantPCLen }}</td>
                    <td class="text-xs-left">{{ props.item.cantPCMat }}</td>
                    <td class="text-xs-left">{{ props.item.cantPCSoc }}</td>
                    <td class="text-xs-left">{{ props.item.cantPCNat }}</td>
                    <td class="text-xs-left">{{ props.item.cantPCEsc }}</td>
                    <td class="text-xs-left">{{ props.item.cantCe }}</td>
                    <td class="text-xs-left">{{ props.item.cantCp }}</td>
                    <td class="text-xs-left">{{ props.item.cantCd }}</td>
                    <td class="text-xs-left">{{ props.item.cantDl }}</td>
                    <td class="text-xs-left">{{ props.item.cantDm }}</td>
                    <td class="text-xs-left">{{ props.item.cantDir }}</td>
                    <td class="text-xs-left">
                      {{ props.item.fechaDestruccion }}
                    </td>
                  </template>
                </v-data-table>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";

export default {
  name: "destruccion-data",
  components: {},
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
    idNivel: "",
    tipoPrueba: "",
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Curso", align: "left", sortable: false, value: "codigoCurso" },
        { text: "Id Nivel", sortable: false, value: "idNivel" },
        { text: "Tipo Prueba", sortable: false, value: "evaluacion" },
        { text: "cantLC", sortable: false, value: "" },
        { text: "cantFa", sortable: false, value: "" },
        { text: "cantPCLen", sortable: false, value: "" },
        { text: "cantPCMat", sortable: false, value: "" },
        { text: "cantPCSoc", sortable: false, value: "" },
        { text: "cantPCNat", sortable: false, value: "" },
        { text: "cantPCEsc", sortable: false, value: "" },
        { text: "cantCe", sortable: false, value: "" },
        { text: "cantCp", sortable: false, value: "" },
        { text: "cantCd", sortable: false, value: "" },
        { text: "cantDl", sortable: false, value: "" },
        { text: "cantPDm", sortable: false, value: "" },
        { text: "cantDir", sortable: false, value: "" },
        { text: "FechaDestruccion", sortable: false, value: "" },
      ],
      itemsDestruccion: [],
      select: { nombre: "Sin asignar" },
      filter: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },

      contratoId: "",
      curso: "",
      nivel: "",
      codCursoValue: "",
      codCursoSelect: [],
      regionValue: "",
      comunaValue: "",
      regionesSelect: [],
      comunasSelect: [],
      tipeArchive: "",
      filenameValue: "",
      filename: "",
      base64Value: "",
      codigo: "",
      destrucciones: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  created() {
    this.loadData();
    this.loadDataComuna();
    // this.loadDataCodigo();
    this.id = this.$route.params.id;
    console.log(this.id);
  },
  mounted() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {},
  methods: {
    submit() {
      this.$v.$touch();
    },

    async loadData() {
      this.id = this.$route.params.id;
      this.destrucciones = await this.loadDestruccion();
      this.itemsDestruccion = this.destrucciones.destruccionLst;
    },

    async loadDestruccion() {
      this.contratoId = this.$store.getters.contratoStored;
      let body = {
        idNivel: this.idNivel,
        tipoPrueba: this.tipoPrueba,
        idContrato: this.contratoId,
      };
      return await axios
        .post("/destruccion/getAllByFilter", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadDataCodigo() {
      this.itemsCodigoCurso = await this.loadCodigoCurso();
      if (this.itemsCodigoCurso.length > 0) {
        this.codCursoSelect = this.itemsCodigoCurso;
      }
    },
    async loadCodigoCurso() {
      return await axios
        .get("/cuadraturas/codigoCurso/" + this.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.codCursoValue = "";
      this.loadData();
    },
  },
};
</script>
